import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { RRModalModel } from '../models/modal.model';
import { RRModalButtonsModel } from '../models/modal-buttons.model';
@Component({
  template: '',
})
export abstract class RRBaseModalComponent {
  public title: string;
  public text: string;
  public buttons: RRModalButtonsModel[] = [];
  public skipFooter: boolean;

  @Input() modalSettings: RRModalModel = new RRModalModel();
  @Input() showModal: boolean;
  @Input() template: TemplateRef<any>;

  @Output() modalHidden: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() modalHide: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() modalShown: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() modalShow: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() showModalChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() clickedButton: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('templateModal') public templateModal: TemplateRef<any>;

  @HostListener('document:mousedown', ['$event'])
  public onMouseDown(event): void {
    if (
      (typeof this.modalSettings.ignoreBackdropClick === 'undefined' ||
        !this.modalSettings.ignoreBackdropClick) &&
      event.target.classList.contains('modal')
    ) {
      this.closeModal();
    }
  }

  public abstract openModal(): void;
  public abstract closeModal(): void;
  public abstract buttonClicked(button: any, match?: string): void;
}
